"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Thumbnail_Skeleton_1 = __importDefault(require("./Thumbnail.Skeleton"));
var Thumbnail_Add_1 = __importDefault(require("./Thumbnail.Add"));
var Thumbnail_Empty_1 = __importDefault(require("./Thumbnail.Empty"));
var Thumbnail_Select_1 = __importDefault(require("./Thumbnail.Select"));
var Thumbnail_Plus_1 = __importDefault(require("./Thumbnail.Plus"));
var Thumbnail_File_1 = __importDefault(require("./Thumbnail.File"));
var Thumbnail_Error_1 = __importDefault(require("./Thumbnail.Error"));
var Thumbnail_Wrapper_1 = __importDefault(require("./Thumbnail.Wrapper"));
var Spinner_1 = require("../Spinner");
require("./Thumbnail.css");
function Thumbnail(_a) {
    var children = _a.children, src = _a.src, altText = _a.altText, aspectRatio = _a.aspectRatio, width = _a.width, _b = _a.loading, loading = _b === void 0 ? false : _b;
    return (React.createElement(Thumbnail_Wrapper_1.default, { aspectRatio: aspectRatio, width: width },
        React.createElement(React.Fragment, null,
            children,
            loading && (React.createElement("div", { className: "nimbus--thumbnail-overlay nimbus--thumbnail-overlay--white" },
                React.createElement(Spinner_1.Spinner, { size: "large" }))),
            React.createElement("img", { src: src, alt: altText, className: "nimbus--thumbnail" }))));
}
Thumbnail.Skeleton = Thumbnail_Skeleton_1.default;
Thumbnail.Add = Thumbnail_Add_1.default;
Thumbnail.File = Thumbnail_File_1.default;
Thumbnail.Plus = Thumbnail_Plus_1.default;
Thumbnail.Empty = Thumbnail_Empty_1.default;
Thumbnail.Select = Thumbnail_Select_1.default;
Thumbnail.Error = Thumbnail_Error_1.default;
exports.default = Thumbnail;
//# sourceMappingURL=Thumbnail.js.map